"use client";
import { jsxs as g, jsx as t } from "react/jsx-runtime";
import j from "../../common/components/input-meta/InputMeta.js";
import b from "../../common/components/input-search/InputSearch.js";
import w from "../../common/components/label/Label.js";
import { useFormCounter as x } from "../../common/hooks/useFormCounter.js";
import { InputFieldWrapper as D } from "../../common/styles/components/InputFieldWrapper.js";
import { useFeId as M } from "../../hooks/useFeId.js";
import { forwardRef as N } from "react";
const s = N(
  ({
    "aria-errormessage": c,
    className: u,
    disabled: n,
    feHideLabel: i,
    feHint: a,
    feLabel: l,
    feRequiredText: d,
    feSeverity: r,
    feSize: o,
    id: e = M(),
    maxLength: m,
    onChange: h,
    ...f
  }, C) => {
    const { counterValue: I, hintId: p, onChangeHandler: F } = x({
      feHint: a,
      feSeverity: r,
      id: e,
      maxLength: m,
      onChange: h
    });
    return /* @__PURE__ */ g(D, { className: u, "data-comp": "search", feSize: o, children: [
      /* @__PURE__ */ t(
        w,
        {
          feDisabled: n,
          feHideLabel: i,
          feRequiredText: d,
          feSize: o,
          htmlFor: e,
          children: l
        }
      ),
      /* @__PURE__ */ t(
        b,
        {
          ...f,
          "aria-errormessage": p ?? c,
          "aria-invalid": r === "error" ? !0 : void 0,
          disabled: n,
          feSeverity: r,
          feSize: o,
          id: e,
          maxLength: m,
          onChange: F,
          ref: C
        }
      ),
      (a ?? m) && /* @__PURE__ */ t(
        j,
        {
          feCharCounter: I,
          feSeverity: r,
          feSize: o,
          id: p,
          children: a
        }
      )
    ] });
  }
);
s.displayName = "Search";
const E = s;
export {
  E as default
};
